export class RecommendationService {
  constructor(recommendationRepository) {
    this.recommendationRepository = recommendationRepository;
  }

  async getPharmInsightGuide(ediCodes, brn) {
    return await this.recommendationRepository.getPharmInsightGuide(ediCodes, brn);
  }
}
